import { useEffect } from "react";
import styles from "./DeletePublicationModal.module.scss";
import Modal from "../Modal/Modal";
import { Button } from "@mui/material";
import { useToast } from "../../helpers/hooks";

interface DeletePublicationModalProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    publication: any;
    onDeleteConfirm: (publicationId: string) => void;
    loading?: boolean;
}

const DeletePublicationModal = ({
    open,
    setOpen,
    publication,
    onDeleteConfirm,
    loading = false
}: DeletePublicationModalProps) => {
    const toast = useToast();

    const handleDelete = () => {
        if (publication?.in_transaction || publication?.reserved) {
            toast("No puedes eliminar una publicación en transacción");
            return;
        }
        onDeleteConfirm(publication?._id);
    };

    return (
        <Modal open={open} variant="white" className={styles.modalContainer}>
            <div className={styles.content}>
                <h2 className={styles.title}>¿Eliminar publicación?</h2>
                <div className={styles.textContainer}>
                    <p className={styles.message}>Esta acción no se puede deshacer.</p>
                    <p className={styles.description}>La publicación dejará de estar visible en Linze y se eliminará de forma permanente.</p>
                </div>
                <div className={styles.buttons}>
                    <Button
                        onClick={() => setOpen(false)}
                        variant="outlined"
                        className={styles.cancelButton}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={() => handleDelete()}
                        variant="contained"
                        className={styles.deleteButton}
                        disabled={loading}
                    >
                        Eliminar
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default DeletePublicationModal;
